import { cloneMaterial } from "../../cloneObject";

export const stulya = [
    {
        key: "gazlift",
        allArray: "allGazlifts",
        activeArray: "activeGazlifts",
        position: "bottom",
    },
    {
        key: "opora",
        allArray: "allOpora",
        activeArray: "activeOpora",
        position: "bottom",
    },
    {
        key: "nozhki",
        allArray: "allNozhkiStula",
        activeArray: "activeNozhkiStula",
        position: "bottom",
        extra: (target) => {
            target.children.forEach((child) => {
                const newMaterial = cloneMaterial(child.material);
                child.material = newMaterial;
            });
        },
    },
    {
        key: "podlokotniki",
        allArray: "allPodlokotniki",
        activeArray: "activePodlokotniki",
        position: "bottom",
    },
    {
        key: "opornoe_koltso",
        allArray: "allOpornoeKoltso",
        activeArray: "activeOpornoeKoltso",
        position: "bottom",
    },
];
